import React, { memo } from 'react'
import { Row, Container } from '@paypalcorp/pp-react'
import { Router } from '@reach/router'
import CaseCreationHome from './case-creation/CaseCreationHome'
import StickyElement from '../../components/zettle/sticky-element/StickyElement'
import ZettleBar from '../../components/zettle/zettle-bar/ZettleBar'
import content from './common/content.json'
import VerificationHome from './case-verification/verification-home'
import DATAPRIVACY_FPTI from '../../config/data-privacy-fpti'

const DSRZettleHome = memo(() => {
  const { ZETTLE_DSR = {} } = DATAPRIVACY_FPTI

  return (
    <div className="privacyZettle_Home privacyZettle_Home-content">
      <div className="privacyZettle_promise">
        <Container form>
          <Row>
            <section className="sticky-element-container">
              <StickyElement>
                <ZettleBar {...content.stickyNavProps} />
              </StickyElement>
            </section>
            <div className="full-width">
              <Router>
                <CaseCreationHome path="/" dsrFpti={ZETTLE_DSR} />
                <VerificationHome path="/verification" dsrFpti={ZETTLE_DSR} />
              </Router>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  )
})
DSRZettleHome.displayName = 'DSRZettleHome'

export default DSRZettleHome
